var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgThunderstormIconWhite = function SvgThunderstormIconWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1982_16435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 19.25L5.25 21.875M7.4375 23.625L6.5625 25.375M21.875 19.25L20.5625 21.875M22.75 23.625L21.875 25.375M11.375 16.625L10.5 21.875H13.125V26.25L17.5 20.125H14.875L15.75 16.625M22.1118 8.36118H21.4484C21.0388 4.64024 17.8358 1.75 14 1.75C12.4589 1.74852 10.9551 2.22445 9.69548 3.11236C8.43584 4.00026 7.48216 5.25656 6.96555 6.70852H6.71563C3.98453 6.70852 1.75 8.93977 1.75 11.6665C1.75 14.3938 3.98453 16.625 6.71563 16.625H22.1118C24.3906 16.625 26.25 14.7656 26.25 12.4928C26.25 10.2206 24.3906 8.36118 22.1118 8.36118Z",
    stroke: "#fff",
    strokeWidth: 2.10732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1982_16435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgThunderstormIconWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "thunderstorm-icon-white.3ede3fe3e70088d1c27fe4926b58c180.svg";